import React, { useState } from 'react';
import { Input } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import {
  addUsedMaterial,
  closedTaskUsedMaterialsListType,
  removeUsedMaterial,
  newUsedMaterialsListType,
} from '../../helperFunctions';

export default props => {
  const { material, smallerFontSize } = props;
  const dispatch = useDispatch();
  const showTaskDetails = useSelector(state => state.tasks.showTaskDetails);
  const newUsedMaterials = useSelector(state => state.tasks.newUsedMaterials);
  const closedTaskUsedMaterials = useSelector(state => state.tasks.closedTaskUsedMaterials);
  const endTaskDialogTaskId = useSelector(state => state.tasks.endTaskDialog.taskId);
  const data = useSelector(state => state.tasks.data);
  const task = data.tasks.find(
    z => z.id === showTaskDetails.taskId || z.id === endTaskDialogTaskId
  );
  const { id, address, appEnd } = task;
  const [quantityValue, setQuantityValue] = useState(null);

  return (
    <Input
      style={{ marginBottom: '0px', padding: '0px' }}
      inputProps={{
        style: { fontSize: smallerFontSize },
        min: 0,
        max: material.quantity,
      }}
      size="small"
      margin="none"
      type="number"
      value={quantityValue}
      onChange={y => {
        const value =
          Number(y.target.value) < material.quantity ? Number(y.target.value) : material.quantity;
        if (value !== 0) {
          setQuantityValue(value);
          addUsedMaterial(
            value,
            material,
            id,
            address,
            newUsedMaterials,
            appEnd,
            closedTaskUsedMaterials,
            dispatch
          );
        } else {
          setQuantityValue(null);
          if (appEnd) {
            removeUsedMaterial(
              material,
              closedTaskUsedMaterials,
              closedTaskUsedMaterialsListType,
              undefined,
              dispatch
            );
          } else {
            removeUsedMaterial(
              material,
              newUsedMaterials,
              newUsedMaterialsListType,
              undefined,
              dispatch
            );
          }
        }
      }}
    />
  );
};
